import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { AddModelButton, DataTable, DataTableRowOptionItem, DeleteModelButton, EditModelButton, Header, Toolbar } from '@lib/ui-components';

export const Wastes = () => {
  const { t } = useTranslation();
  const [tableReloadKey, setTableReloadKey] = React.useState(1);

  const rowOptions: DataTableRowOptionItem[] = [
    {
      renderer: (row) => (
        <EditModelButton
          id={row['id']}
          entity={row}
          url='/api/resource/wastes'
          buttonLabel={t('edit')}
          dialogTitle={t('Button.WasteModel.edit.dialog.title')}
          fields={[
            { field: 'code', label: t('wasteCode'), type: 'text' },
            { field: 'description', label: t('wasteDescription'), type: 'text' },
            { field: 'hazardous', label: t('Model.Waste.hazardous'), type: 'boolean' },
            {
              field: 'hazardousProperties',
              label: t('Model.Waste.hazardousProperties'),
              type: 'table-multi-select',
              isVisible: (data) => data.hazardous === true,
              tableSelectByApiParams: {
                apiPostEndpoint: '/api/waste/hazardous-properties',
                displayFormat: '{code}',
                dialogTitle: t('Model.Waste.selectHazardousProperties'),
                selectedValueField: 'code',
                preserveApiOrder: true,
                columns: [
                  {
                    key: 'code',
                    label: t('Model.Waste.hazardousPropertyCode'),
                    type: 'text',
                  },
                ],
              },
              initialValues: row['hazardousProperties'] || [],
              initialDisplayedValues: row['hazardousProperties'] ? row['hazardousProperties'].join(', ') : '',
            },
          ]}
          validationSchema={{
            code: Yup.string().required(t('Model.Waste.code.required')),
            description: Yup.string().required(t('Model.Waste.description.required')),
          }}
          onBeforeSave={(formData) => {
            if (!formData.hazardous) {
              formData.hazardousProperties = [];
            }
            return formData;
          }}
          onSaved={async () => setTableReloadKey(tableReloadKey + 1)}
          yellowIcon
        />
      ),
    },
    {
      renderer: (row) => <DeleteModelButton id={row['id']} url='/api/resource/wastes' onDeleted={async () => setTableReloadKey(tableReloadKey + 1)} />,
    },
  ];

  const rightButtons: JSX.Element[] = [
    <AddModelButton key='add-model-button-67'
      url='/api/resource/wastes'
      buttonLabel={t('Button.WasteModel.add')}
      dialogTitle={t('Button.WasteModel.add.dialog.title')}
      fields={[
        { field: 'code', label: t('wasteCode'), type: 'text' },
        {
          field: 'description',
          label: t('wasteDescription'),
          type: 'text',
        },
        { field: 'hazardous', label: t('Model.Waste.hazardous'), type: 'boolean' },
        {
          field: 'hazardousProperties',
          label: t('Model.Waste.hazardousProperties'),
          type: 'table-multi-select',
          isVisible: (data) => data.hazardous === true,
          tableSelectByApiParams: {
            apiPostEndpoint: '/api/waste/hazardous-properties',
            displayFormat: '{code}',
            dialogTitle: t('Model.Waste.selectHazardousProperties'),
            selectedValueField: 'code',
            preserveApiOrder: true,
            columns: [
              {
                key: 'code',
                label: t('Model.Waste.hazardousPropertyCode'),
                type: 'text',
              },
            ],
          },
        },
      ]}
      validationSchema={{
        code: Yup.string().required(t('Model.Waste.code.required')),
        description: Yup.string().required(t('Model.Waste.description.required')),
      }}
      onBeforeSave={(formData) => {
        if (!formData.hazardous) {
          formData.hazardousProperties = [];
        }
        return formData;
      }}
      onSaved={async () => setTableReloadKey(tableReloadKey + 1)}
    />,
  ];

  return (
    <>
      <Header label={t('GlobalSettings.wastes.header')} />
      <Toolbar right={rightButtons} />
      <DataTable
        refreshKey={tableReloadKey}
        fetchUrl={'/api/resource/wastes'}
        columns={[
          {
            key: 'code',
            label: t('wasteCode'),
            type: 'text',
          },
          {
            key: 'description',
            label: t('wasteDescription'),
            type: 'text',
          },
          {
            key: 'hazardous',
            label: t('Model.Waste.hazardous'),
            type: 'boolean',
          },
          {
            key: 'hazardousProperties',
            label: t('Model.Waste.hazardousProperties'),
            type: 'text',
            renderer: (row) => (row.hazardousProperties ? row.hazardousProperties.join(', ') : ''),
          },
        ]}
        rowOptions={rowOptions}
      />
    </>
  );
};
